module.exports = __webpack_public_path__ + "static/media/logo-facebook-hover.63c80e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-facebook-hover.svg
// module id = 683
// module chunks = 0